import React, { useState, useEffect, useRef } from 'react';
import ApiService from '../../../services/ApiService';

const Products = () => {
    const [products, setProducts] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const loader = useRef(null);

    const fetchProducts = async (page) => {
        try {
            const token = JSON.parse(localStorage.getItem('user')).access_token;
            const response = await ApiService.getProducts(token, page);
            const newProducts = response.data.data; // Adjust according to your response structure

            setProducts((prev) => [...prev, ...newProducts]);

            if (response.data.next_page_url === null) { // Check if there are more pages
                setHasMore(false);
            }
        } catch (error) {
            console.error('Failed to fetch products', error);
        }
    };

    useEffect(() => {
        fetchProducts(page);
    }, [page]);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            const target = entries[0];
            if (target.isIntersecting && hasMore) {
                setPage((prev) => prev + 1);
            }
        }, { root: null, rootMargin: '20px', threshold: 1.0 });

        const currentLoader = loader.current; // Store ref value in a variable

        if (currentLoader) {
            observer.observe(currentLoader);
        }

        return () => {
            if (currentLoader) observer.unobserve(currentLoader);
        };
    }, [hasMore]);

    return (
        <div>
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Products</h1>
                <a href="/" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                    <i className="fas fa-download fa-sm text-white-50"></i> Download
                </a>
            </div>
            <table className="table table-hover table-bordered">
                <thead>
                    <tr>
                        <th>Action</th>
                        <th>ProductName</th>
                        <th>Supplier</th>
                        <th>Category</th>
                        <th>Unit</th>
                        <th>Price</th>
                        <th>Photo</th>
                    </tr>
                </thead>
                <tbody>
                    {products.map((product, index) => (
                        <tr key={index}>
                            <td><button className="btn btn-sm btn-info">Edit</button></td>
                            <td>{product.ProductName}</td>
                            <td>{product.SupplierName}</td>
                            <td>{product.CategoryName}</td>
                            <td>{product.Unit}</td>
                            <td>{product.Price}</td>
                            <td><img src={product.product_image} alt={product.ProductName} style={{ width: '100px', height: 'auto' }} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div ref={loader} style={{ height: '100px', margin: '10px' }}>
                {hasMore && 'Loading more products...'}
            </div>
        </div>
    );
};

export default Products;
